/**
 * @file Constantes de timing internes au flow de réservation.
 * @module packages.common.components.table-reservation.constants.timing
 *
 * Sous-ensemble minimal extrait des constantes de timing du widget : seules les
 * transitions d'étapes sont utilisées par `useReservationSteps`. Co-localisées
 * ici pour rendre le flow autonome, sans dépendre des constantes spécifiques au
 * widget embarquable (resize iframe, debounce, etc.).
 */

export const TIMING = {
  /** Délai avant transition entre deux étapes consécutives (ms). */
  STEP_TRANSITION: 50,

  /** Délai avant un saut direct d'étape via le breadcrumb (ms). */
  STEP_GOTO_TRANSITION: 30,
};
